import l from "../../node_modules/.pnpm/dayjs@1.10.7/node_modules/dayjs/dayjs.min.js";
const X = [
  "category_chugui_XYXX",
  // 橱柜小样选型
  "category_jinshumenchuang_XYXX",
  // 金属门窗小样选型
  "category_mumen_XYXX",
  // 木门小样选型
  "category_weiyu_XYXX",
  // 卫浴小样选型
  "category_yigui_XYXX",
  // 衣柜小样选型
  "category_zhuangjiamen_XYXX",
  // 装甲门小样选型
  "category_weiyu_210"
  // 卫浴标准柜
], i = 80;
function r(t) {
  return l().add(t, "day").startOf("day").valueOf();
}
function _(t, a, u) {
  if (!t)
    return !0;
  const e = r(i);
  if (t > e)
    return !1;
  const n = a != null ? a : u;
  if (n != null) {
    const c = r(n + 1);
    return t >= c;
  }
  return !0;
}
function f(t, a) {
  return (u) => {
    const e = t != null ? t : a;
    if (e != null) {
      const n = r(i);
      if (u > n)
        return !0;
    }
    if (e != null) {
      const n = r(e + 1);
      return u < n;
    }
    return !1;
  };
}
export {
  i as MAX_DELIVERY_DAYS,
  X as REQUIRED_CYCLE_CATEGORIES,
  f as getDateDisabledFunction,
  _ as validateDeliveryDate
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/order-cycle/utils.js
// module id = 832
// module chunks = 41